import React, {useState} from "react";
import {Alert, Button, Modal, Spinner} from "react-bootstrap";
import axios from "axios";
import {formatNumber} from "../Statistics/format.js";

/**
 * Eigener Sicherheitsabfrage-Dialog vor dem endgültigen Aufräumen - bewusst
 * KEIN confirm() (globale Vorgabe gegen browsereigene Bedienelemente). Die
 * Zahlen aus der Vorschau stehen hier noch einmal, damit die Entscheidung
 * nicht "blind" getroffen wird.
 */
export default function NutzungAufraeumenDialog({show, eintrag, formatBytes, onClose, onErledigt}) {
    const [laufend, setLaufend] = useState(false);
    const [fehler, setFehler] = useState(null);
    const [ergebnis, setErgebnis] = useState(null);

    if (!eintrag) {
        return null;
    }

    const schliessen = () => {
        if (laufend) {
            return;
        }
        setErgebnis(null);
        setFehler(null);
        onClose();
    };

    const aufraeumen = async () => {
        setLaufend(true);
        setFehler(null);
        try {
            const {data} = await axios.post("/nutzung/daten/aufraeumen", {aelter_als_tage: eintrag.aelter_als_tage});
            setErgebnis(data);
            onErledigt?.();
        } catch (e) {
            setFehler(e.response?.data?.message || e.message || "Das Aufräumen ist fehlgeschlagen.");
        } finally {
            setLaufend(false);
        }
    };

    return (
        <Modal show={show} onHide={schliessen} centered backdrop={laufend ? "static" : true}>
            <Modal.Header closeButton={!laufend}>
                <Modal.Title as="h2" className="h5 mb-0">
                    {ergebnis ? "Aufräumen abgeschlossen" : "Wirklich aufräumen?"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!ergebnis ? (
                    <>
                        <p className="mb-2">
                            Es werden alle Rohereignisse und Datenänderungen{" "}
                            <strong>älter als {eintrag.aelter_als_tage} Tage</strong> unwiderruflich gelöscht.
                        </p>
                        <ul className="mb-3">
                            <li><strong>{formatNumber(eintrag.zeilen)}</strong> Zeilen betroffen</li>
                            <li>rund <strong>{formatBytes(eintrag.bytes)}</strong> werden freigegeben</li>
                        </ul>
                        <Alert variant="light" className="border small mb-0">
                            Die Verdichtung (Tagesauswertung für Diagramme) bleibt in jedem Fall erhalten -
                            Diagramme über lange Zeiträume funktionieren danach unverändert weiter.
                        </Alert>
                        {fehler && <Alert variant="danger" className="mt-3 mb-0">{fehler}</Alert>}
                    </>
                ) : (
                    <>
                        <p className="mb-2">
                            <strong>{formatNumber(ergebnis.geloeschte_ereignisse)}</strong> Ereignisse und{" "}
                            <strong>{formatNumber(ergebnis.geloeschte_aenderungen)}</strong> Datenänderungen wurden gelöscht.
                        </p>
                        <Alert variant="light" className="border small mb-0">{ergebnis.hinweis}</Alert>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                {!ergebnis ? (
                    <>
                        <Button variant="link" className="text-muted" onClick={schliessen} disabled={laufend}>
                            Abbrechen
                        </Button>
                        <Button variant="danger" onClick={aufraeumen} disabled={laufend}>
                            {laufend ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Wird aufgeräumt…
                                </>
                            ) : (
                                "Endgültig löschen"
                            )}
                        </Button>
                    </>
                ) : (
                    <Button variant="primary" onClick={schliessen}>Schließen</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
